var $ = require('jquery');

module.exports = function(el, isResult) {
  return $('<span>')
    .addClass('b-selectbox-dropdown_item')
    .addClass('b-selectbox-dropdown_item__heading')
    .text(el.attr('label'));
};
